'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

function BackScrollTop() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        (
            document.getElementById('scrollbox')?.children[0] as HTMLDivElement
        ).onscroll = function () {

            let scrTop =document.getElementById('scrollbox')?.children[0].scrollTop;
            if (scrTop && scrTop > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
    }, []);


    const BackScrollTop=()=>{
        (document.getElementById('scrollbox')?.children[0] as HTMLDivElement).scrollTo({top:0, behavior: "smooth" })
    }

    return (
        <>
            <Image
                onClick={BackScrollTop}
                className={`fixed right-[15px] bottom-[130px] transition-opacity duration-500 ${
                    isVisible ? 'opacity-100' : 'opacity-0'
                }`}
                src="/m_img/gotop.png"
                alt=""
                width={50}
                height={50}
            />
        </>
    );
}

export default BackScrollTop;
